export var BuildingType;
(function (BuildingType) {
    BuildingType["TOWN_HALL"] = "TOWN_HALL";
    BuildingType["ACADEMY"] = "ACADEMY";
    BuildingType["BARRACKS"] = "BARRACKS";
    BuildingType["SHIPYARD"] = "SHIPYARD";
    BuildingType["WAREHOUSE"] = "WAREHOUSE";
    BuildingType["TAVERN"] = "TAVERN";
    BuildingType["TRADING_POST"] = "TRADING_POST";
    BuildingType["HARBOR"] = "HARBOR";
    BuildingType["WALL"] = "WALL";
    BuildingType["HIDEOUT"] = "HIDEOUT";
})(BuildingType || (BuildingType = {}));
//# sourceMappingURL=buildings.js.map